import { MutableRefObject } from "react";

import { CommonListProps } from "@/common/types/ListFromApi.types";
import { IMessageBar } from "@/core/libs/message-bar";

export enum ServicesCategoriesTypesEnum {
  ADHERENCE = "ADHERENCE",
  BROADBAND = "BROADBAND",
  LINK_DEDICATED = "LINK_DEDICATED",
  MOBILE_LINE = "MOBILE_LINE",
  MOBILE_LINE_PRE = "MOBILE_LINE_PRE",
  PABX = "PABX",
  TAG = "TAG",
  ENERGY = "ENERGY"
}

export enum TranslatedServicesCategoriesTypesEnum {
  ADHERENCE = "Adesão",
  BROADBAND = "Internet Fixa",
  LINK_DEDICATED = "Link Dedicado",
  MOBILE_LINE = "Linha Móvel",
  MOBILE_LINE_PRE = "Linha Móvel Pré",
  PABX = "PABX",
  TAG = "Tag",
  ENERGY = "Energia"
}

export interface ServiceCategoryItem {
  id: number;
  name: string;
  type: ServicesCategoriesTypesEnum;
  services: number;
  billerIntegrationId: string;
}

export interface ListOfServicesCategories extends CommonListProps {
  items?: ServiceCategoryItem[];
}

export type ServicesCategoriesProps = {
  canCreate: boolean;
  canEdit: boolean;
};

export type CreateProps = {
  create: (values, { setSubmitting }, closeDrawer, isAdmin) => void;
  closeDrawer: () => void;
  dismissMessage: () => void;
  drawerContainerRef: MutableRefObject<HTMLDivElement>;
  message: IMessageBar;
};

export type EditProps = {
  edit: (values, { setSubmitting }, closeDrawer, isAdmin) => void;
  closeDrawer: () => void;
  dismissMessage: () => void;
  drawerContainerRef: MutableRefObject<HTMLDivElement>;
  message: IMessageBar;
  selectedItemId: string;
};
